// extracted by css-extract-rspack-plugin
export default {"shareIcon":"share-menu-option-module__shareIcon___oSOj7"};